// API Configuration
export { default as api } from "./api";

// Services
export * from "./post";
export * from "./user";
export * from "./comment";
export * from "./taxonomy";

// Re-export types for convenience
export type { PostsResponse, PostFilters } from "./post";

export type {
  Comment,
  CommentsResponse,
  ReplyParams,
  CommentSuggestion,
} from "./comment";
